import React from "react";
import { Rewind, ArrowSquareOut, Info as InfoIcon, PlayCircle } from "@phosphor-icons/react";
import { VIRTUAL_PLATFORM } from "@/lib/virtual";

// The Replays tab is now a gateway to the standalone DFTB26 Virtual Platform
// at virtual.dftb26.com. Internal Vimeo embeds have been retired — every talk
// is hosted on the virtual platform until June 2027.
export default function Watch() {
  return (
    <div data-testid="watch-page" className="space-y-5">
      <div>
        <div className="flex items-center gap-2 mb-1">
          <Rewind size={18} weight="fill" className="text-[#DC4F48]" />
          <span className="font-mono-time text-xs uppercase tracking-widest text-[#7A828C]">
            Catch up on DFTB26
          </span>
        </div>
        <h1 className="font-display text-3xl sm:text-4xl tracking-tight">Replays</h1>
        <p className="text-sm text-[#5a5a5a] mt-1">{VIRTUAL_PLATFORM.subline}.</p>
      </div>

      {/* Hero CTA */}
      <a
        href={VIRTUAL_PLATFORM.url}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="watch-virtual-cta"
        className="block p-5 bg-[#000000] text-[#FFFFFF] rounded-sm hover:bg-[#1c1c24] transition-colors group"
      >
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 grid place-items-center rounded-sm bg-[#43C4E3]/15 text-[#43C4E3] flex-shrink-0">
            <PlayCircle size={28} weight="fill" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-display text-xl sm:text-2xl leading-tight">
              {VIRTUAL_PLATFORM.headline}
            </div>
            <div className="text-sm text-[#FFFFFF]/80 mt-1 leading-relaxed">
              {VIRTUAL_PLATFORM.description}
            </div>
            <div className="mt-3 inline-flex items-center gap-2 font-mono-time text-xs uppercase tracking-widest text-[#43C4E3] group-hover:text-[#FFFFFF] transition-colors">
              <span data-testid="watch-virtual-host">{VIRTUAL_PLATFORM.host}</span>
              <ArrowSquareOut size={14} weight="bold" />
            </div>
          </div>
        </div>
      </a>

      {/* Login note */}
      <div
        data-testid="watch-virtual-login-note"
        className="p-4 bg-[#FFF8E5] border border-[#E8D58A] rounded-sm flex items-start gap-3"
      >
        <InfoIcon size={20} weight="duotone" className="text-[#7a5a00] flex-shrink-0 mt-0.5" />
        <div className="text-sm text-[#5a4500] leading-relaxed">
          <strong className="block text-[#1c1c24] mb-1">Need to log in?</strong>
          {VIRTUAL_PLATFORM.login_note}
        </div>
      </div>

      {/* What you'll find */}
      <div className="p-4 bg-[#FFFFFF] border border-[#E5E9F0] rounded-sm space-y-2">
        <div className="font-mono-time text-[10px] uppercase tracking-widest text-[#7A828C]">
          What you&apos;ll find on the virtual platform
        </div>
        <ul className="text-sm text-[#1c1c24] space-y-1.5 leading-relaxed list-disc pl-5">
          <li>Every keynote, parallel session and workshop from Mon 22 - Wed 24 June 2026.</li>
          <li>Speaker slides where shared.</li>
          <li>Available until June 2027 - plenty of time to catch up.</li>
        </ul>
      </div>

      {/* Secondary open-in-new-tab button (bigger touch target) */}
      <a
        href={VIRTUAL_PLATFORM.url}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="watch-virtual-open-btn"
        className="block text-center p-3 bg-[#43C4E3] text-[#000000] font-display font-medium rounded-sm hover:bg-[#0099B8] hover:text-[#FFFFFF] transition-colors"
      >
        Open {VIRTUAL_PLATFORM.host}
        <ArrowSquareOut size={14} weight="bold" className="inline ml-1.5 -mt-0.5" />
      </a>
    </div>
  );
}
